import { Plus } from "lucide-react";

interface AddItemSectionProps {
  onAddItem: () => void;
}

const AddItemSection: React.FC<AddItemSectionProps> = ({ onAddItem }) => {
  return (
    <button
      onClick={onAddItem}
      className="inline-flex items-center gap-1 rounded-md border border-border bg-card px-3 py-1.5 text-sm shadow-sm transition-all hover:bg-muted hover:shadow"
    >
      <Plus className="h-4 w-4" />
      Add Item
    </button>
  );
};

export default AddItemSection;
